import appInsights from '../Config/appInsights';
import appConfig from '../Config/appConfig';

const journeyStorageKey = 'suttersync.journeyId';

const createId = (prefix) => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID()}`;
  }

  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getJourneyId = () => {
  try {
    const existingId = window.sessionStorage.getItem(journeyStorageKey);
    if (existingId) return existingId;

    const journeyId = createId('journey');
    window.sessionStorage.setItem(journeyStorageKey, journeyId);
    return journeyId;
  } catch (error) {
    return createId('journey');
  }
};

export const createRequestContext = (operation, journeyId = getJourneyId()) => ({
  requestId: createId(operation),
  journeyId,
});

export const trackTelemetry = (name, properties = {}) => {
  const telemetry = appInsights.appInsights;
  if (!telemetry || typeof telemetry.trackEvent !== 'function') return;

  telemetry.trackEvent({ name }, {
    app: 'SutterSync-UI',
    journeyId: properties.journeyId || getJourneyId(),
    ...properties,
  });
};

export const getLaunchProperties = (launchCode) => ({
  hasLaunchCode: Boolean(launchCode),
  launchCodeLength: launchCode ? String(launchCode).length : 0,
});

// Temporary debugging flag for the live Epic handshake issue — must stay off outside active debugging.
export const isEpicHandshakeLogEnabled = () =>
  String(appConfig.EpicHandshakeLogEnabled || '').toLowerCase() === 'true';

// Temporary debugging flag: shows the raw task/auth error dump on-screen instead of the
// generic friendly message. Must stay off outside active debugging (can surface backend detail).
export const isErrorDetailsEnabled = () =>
  String(appConfig.ShowErrorDetailsEnabled || '').toLowerCase() === 'true';

export const getRawLaunchProperty = (launchCode) => ({
  ...(launchCode && isEpicHandshakeLogEnabled() ? { rawLaunchCode: String(launchCode) } : {}),
});

export const getTokenDiagnostics = (authToken = {}) => ({
  hasAccessToken: Boolean(authToken.access_token),
  accessTokenLength: authToken.access_token ? String(authToken.access_token).length : 0,
  hasRefreshToken: Boolean(authToken.refresh_token),
  refreshTokenLength: authToken.refresh_token ? String(authToken.refresh_token).length : 0,
});

export const getLaunchPropertiesFromLocation = () => {
  if (typeof window === 'undefined') return getLaunchProperties(null);

  const launchCode = new URLSearchParams(window.location.search).get('launch');
  return getLaunchProperties(launchCode);
};